<div [class]="colorClass()"></div>
{{ formattedValue() }}
